import React, { useState } from 'react';
import { ChannelList, useChatContext } from 'stream-chat-react';
import Cookies from 'universal-cookie';
import FreelancerIcon from '../assets/freelancer.png'
import LogoutIcon from '../assets/logout.png';
import { ChannelSearch, TeamChannelList, TeamChannelPreview } from './';

const cookies = new Cookies();

const SideBar = ({logout}) => (
  <div className="channel-list__sidebar">
      <div className="channel-list__sidebar__icon1">
          <div className="icon1__inner">
              <img src={FreelancerIcon} alt="Freelancer" width="30" />
          </div>
      </div>
      <div className="channel-list__sidebar__icon2">
          <div className="icon1__inner" onClick={logout}>
              <img src={LogoutIcon} alt="Logout" width="30" />
          </div>
      </div>
  </div>
);

const CompanyHeader = () => (
  <div className="channel-list__header">
      <p className="channel-list__header__text">Freelance Community</p>
  </div>
)

const customChannelTeamFilter = (channels) => {
   return channels.filter((channel) => channel.type === 'team')
}

const customChannelMessagingFilter = (channels) => {
  return channels.filter((channel) => channel.type === 'messaging')
}

const ChannelListContent = ({isCreating, setIsCreating, setCreateType, setIsEditing, setToggleContainer}) => {

  const { client } = useChatContext();

  const logout = () => {
        cookies.remove("token"); 
        cookies.remove('userId'); //these id, name.. should be exactly named as it is here coz they are stored in connectUser(getStream - Chat - ecxplore - userdetails) like that
        cookies.remove('username');
        cookies.remove('avatarURL');
        cookies.remove('fullName');
        cookies.remove('phoneNumber');
        cookies.remove('hashedPassword');

        window.location.reload(); //gets us back to auth page 
  }

  const filters = { members: { $in: [client.userID] }};

  return (
    <>
      <SideBar logout={logout} />
      <div className="channel-list__list__wrapper">
          <CompanyHeader />
          <ChannelSearch setToggleContainer={setToggleContainer}/>
          <ChannelList 
             filters={filters} /* for filtering the messages */
             channelRenderFilterFn={customChannelTeamFilter} /* This will just filter out direct msgs and look in team chats only */
             List={(listProps) => (
               <TeamChannelList //This our custom comp will get all the props that the channel list would usually get using stream
                    {...listProps}
                    type="team" /** this channellist is for group msgs */
                    isCreating={isCreating}
                    setIsCreating={setIsCreating}
                    setCreateType={setCreateType}
                    setIsEditing={setIsEditing}
                    setToggleContainer={setToggleContainer}
               />
             )} /* for rendering custom lists */
             Preview={(previewProps) => (
               <TeamChannelPreview 
                    {...previewProps}
                    setIsCreating={setIsCreating}
                    setIsEditing={setIsEditing}
                    setToggleContainer={setToggleContainer}
                    type="team"
               />
             )}
          />

          <ChannelList 
             filters={filters} 
             channelRenderFilterFn={customChannelMessagingFilter} 
             List={(listProps) => (
               <TeamChannelList 
                    {...listProps}
                    type="messaging" /** this channellist is for direct msgs */
                    isCreating={isCreating}
                    setIsCreating={setIsCreating}
                    setCreateType={setCreateType}
                    setIsEditing={setIsEditing}
                    setToggleContainer={setToggleContainer}
               />
             )} 
             Preview={(previewProps) => (
               <TeamChannelPreview 
                    {...previewProps}
                    setIsCreating={setIsCreating}
                    setIsEditing={setIsEditing}
                    setToggleContainer={setToggleContainer}
                    type="messaging"
               />
             )}
          />
      </div>
    </>
    );
};

const ChannelListContainer = ({ setCreateType, setIsCreating, setIsEditing }) => {
  const [toggleContainer, setToggleContainer] = useState(false);

  return (
    <>
        <div className="channel-list__container"> {/* This is for desktop version - always visible */}
          <ChannelListContent 
            setIsCreating={setIsCreating} 
            setCreateType={setCreateType} 
            setIsEditing={setIsEditing} 
          />
        </div>

        <div className="channel-list__container-responsive"
            style={{ left: toggleContainer ? "0%" : "-89%", backgroundColor: "#005fff"}}
        > {/* This is for mobile version. 11% of the div will be always visible. It'll be pulled from the left side if needed(-89% for hiding it) */}
            <div className="channel-list__container-toggle" onClick={() => setToggleContainer((prevToggleContainer) => !prevToggleContainer)}>
            </div>
            <ChannelListContent 
            setIsCreating={setIsCreating} 
            setCreateType={setCreateType} 
            setIsEditing={setIsEditing}
            setToggleContainer={setToggleContainer} //Calling this comp again for mobile version
          />
        </div>
    </>
)
}

export default ChannelListContainer;
